import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../../shared/apiRoutes";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import CommonService from "../../shared/services/commonService";
import type { RootState } from "../store";

//module
import { addEditCartProductsPayload, addCartProductsResponse, categories, createAnonymousCustomer, customerDetails, getAllPosCategoriesForSellscreen, getAllPOSCustomer, getCartProductPayload, getCartProductResponse, getPosCategoryProductsForSellScreen, productList, updateCartProductsResponse, selectedCustomerType, retriveSaleType, getAllEligibleDiscountPayload, getAllEligibleDiscountResponse, overAllDiscount, getOneCouponRestrictionDetailsType, localCartProductType, checkoutDiscountsType, checkoutSummaryType, getCartProductProps, cartProductsMapType, validationCouponType, checkoutNotesType, getAllGiftCardForSellscreenResponse, CheckoutGiftCart, checkoutPayload, checkoutSummaryResponse, placeOrderResponse, placeOrderPayload, splitPaymentDataType, GiftCardResponse, SingleGiftCardResponse, GiftCardDetails } from "../../components/sellScreen/sellScreenModule";
import { ZenToast } from "zen-core-elements";
import { getOneGiftCardResponse } from "../../components/payment/paymentModule";

let couponInitialValue: NonNullable<checkoutDiscountsType["couponDiscount"]> = { value: "", type: "Fixed", code: "", discount: "", restrictionType: "NONE", minValue: null, discountId: -1 }
let discountsInitialValue: NonNullable<checkoutDiscountsType["additionalDiscount"]> = { value: "", type: "Fixed", discount: "" }
let customerNotesInitialValue: checkoutNotesType = { customerNotes: "", orderNotes: "" }
let checkoutSummaryInitialValues: checkoutSummaryType = [
    { name: "SubTotal", value: 0 },
    { name: "Other Discount", value: 0 },
    { name: "Coupon Discount", value: couponInitialValue },
    { name: "Additional Discount", value: discountsInitialValue },
    { name: "Discounted Price", value: 0 },
    { name: "Tax", value: 0 },
    { name: "Pickup Charge", value: 0 },
    { name: "Additional Charge", value: discountsInitialValue },
    { name: "Tip", value: 0, type: "Fixed", tip: 0 }
]
let checkoutGrandTotalInitialValue = { value: 0, quantity: 0, productCount: 0 }

interface InitialState {

    sellScreenCategories: CommonType & { value: categories[] }
    sellScreenProducts: CommonType & { value: productList[], endReached: boolean }
    createAnonymousCustomer: CommonType,
    getAllPOSCustomer: CommonType & { value: customerDetails[] }
    isGiftCardList: boolean
    sellscreenGiftCardList: getAllGiftCardForSellscreenResponse["giftCard"]

    selectedCustomer: selectedCustomerType | null
    retrievingSales: retriveSaleType[]
    getAllEligibleDiscount: overAllDiscount[]
    checkoutProducts: localCartProductType[]
    cartProductsForDetails: cartProductsMapType
    cartProductsForList: cartProductsMapType
    checkoutDiscounts: checkoutDiscountsType
    checkoutNotes: checkoutNotesType
    checkoutSummary: checkoutSummaryType
    sellscreenLoader: boolean
    checkoutGrandTotal: { value: number, quantity: number, productCount: number }
    checkoutGiftCart: CheckoutGiftCart | null

    checkoutSummaryResponse: checkoutSummaryResponse["checkoutData"] | null
    splitPaymentPaidData: splitPaymentDataType[]
}
interface CommonType {
    loading: boolean,
    error: string | null,
}
const initialState: InitialState = {
    sellScreenCategories: { loading: false, error: null, value: [] },
    sellScreenProducts: { loading: false, error: null, value: [], endReached: false },
    createAnonymousCustomer: { error: null, loading: false },
    getAllPOSCustomer: { error: null, loading: false, value: [] },
    isGiftCardList: false,
    sellscreenGiftCardList: [],

    selectedCustomer: null,
    retrievingSales: [],
    getAllEligibleDiscount: [],
    cartProductsForDetails: new Map([]),
    cartProductsForList: new Map([]),
    checkoutProducts: [],
    checkoutDiscounts: {},
    checkoutNotes: customerNotesInitialValue,
    checkoutSummary: checkoutSummaryInitialValues,
    sellscreenLoader: false,
    checkoutGrandTotal: checkoutGrandTotalInitialValue,
    checkoutGiftCart: null,
    checkoutSummaryResponse: null,
    splitPaymentPaidData: []
}
export const getAllCategoriesForSellscreen = createAsyncThunk("sellScreen/getAllCategoriesForSellscreen", ({ storeId }: { storeId: number }) => {
    let url = HttpRoutingService?.replaceUrl(API?.getAllPosCategories, { storeId: storeId })
    return HttpRoutingService?.getMethod<getAllPosCategoriesForSellscreen>(url + "/list")
})
export const getCategoryProductsForSellScreen = createAsyncThunk("sellScreen/getCategoryProductsForSellScreen", ({ storeId, payload }: { storeId: number, payload: { limit: number, offset: number, categoryId: string, searchText: string, locationId: number } }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllPosProductList, { storeId: storeId })
    return HttpRoutingService?.getMethod<getPosCategoryProductsForSellScreen>(url + "/list", payload)
})

export const createAnonymousCustomerApi = createAsyncThunk("sellScreen/createAnonymousCustomer", ({ storeId, data }: { storeId: number, data: { firstName: string, lastName: string, medium: "POS" } }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllPOSCustomer, { storeId: storeId })
    return HttpRoutingService?.postMethod<createAnonymousCustomer>(url + "/anonymous", data, null, "v2/")
})
export const getAllPOSCustomerApi = createAsyncThunk("sellScreen/getAllPOSCustomer", ({ storeId, data }: { storeId: number, data: { searchText: string } }) => {
    let url = HttpRoutingService?.replaceUrl(API?.getAllPOSCustomer + "/", { storeId: storeId })
    return HttpRoutingService?.getMethod<getAllPOSCustomer>(url + "name", data)
})
export const getCartProducts = createAsyncThunk("sellScreen/getCartProducts", ({ storeId, customerId, timeZone, locationId, industryName }: getCartProductProps) => {
    let payload: getCartProductPayload = {
        currentDate: new Date().toISOString(),
        industryName,
        isCart: true,
        isPos: true,
        locationId,
        storeId,
        timeZone
    }
    let url = HttpRoutingService?.replaceUrl(API?.getAuthorizedCartProduct, { storeId, customerId })
    return HttpRoutingService?.getMethod<getCartProductResponse>(url, payload, "v1/")
})
export const addCartProducts = createAsyncThunk("sellScreen/addCartProducts", ({ storeId, payload, customerId }: { storeId: number, customerId: number, payload: addEditCartProductsPayload }) => {
    let url = HttpRoutingService?.replaceUrl(API?.getAuthorizedCartProduct, { storeId, customerId })
    return HttpRoutingService?.postMethod<addCartProductsResponse>(url, payload)
})
export const updateCartProducts = createAsyncThunk("sellScreen/updateCartProducts", ({ storeId, cartProductId, payload }: { storeId: number, cartProductId: number, payload: addEditCartProductsPayload }) => {
    let url = HttpRoutingService?.replaceUrl(API?.cartProductId, { storeId, cartProductId })
    return HttpRoutingService?.putMethod<updateCartProductsResponse>(url, payload, null)
})
export const deleteCartProduct = createAsyncThunk("sellScreen/deleteCartProduct", ({ storeId, cartProductId }: { storeId: number, cartProductId: number }) => {
    let url = HttpRoutingService?.replaceUrl(API?.cartProductId, { storeId, cartProductId })
    return HttpRoutingService?.deleteMethod(url)
})
export const deleteCart = createAsyncThunk("sellScreen/deleteCart", ({ storeId, cartProductIds }: { storeId: number, cartProductIds: number[], isDeleteCustomer: boolean }) => {
    let url = HttpRoutingService?.replaceUrl(API?.deleteCart, { storeId })
    return HttpRoutingService?.postMethod(url, { id: cartProductIds })
})
export const getAllEligibleDiscount = createAsyncThunk("sellScreen/getAllEligibleDiscount", async ({ storeId, payload }: { storeId: number, payload: getAllEligibleDiscountPayload }, { getState }) => {
    let url = HttpRoutingService?.replaceUrl(API.getAllEligibleDiscount, { storeId })
    const response = await HttpRoutingService?.postMethod<getAllEligibleDiscountResponse>(url, payload)
    // Captured here because the store cannot be read while the reducer is executing
    const currencySymbol: string = (getState() as RootState)?.common?.currentUser?.value?.purchasedCurrency?.currencySymbol ?? '₹'
    return { ...response, currencySymbol }
})
export const getOneCouponRestrictionDetails = createAsyncThunk("sellScreen/getOneCouponRestrictionDetails", ({ storeId, restrictionId }: { storeId: number, restrictionId: number }) => {
    let url = HttpRoutingService?.replaceUrl(API?.getOneCouponRestrictionDetails, { storeId, restrictionId })
    return HttpRoutingService?.getMethod<getOneCouponRestrictionDetailsType>(url)
})

export const getAllGiftCardsForSellScreen = createAsyncThunk("sellScreen/getAllGiftCardsForSellScreen", ({ storeId }: { storeId: number }) => {
    let url = HttpRoutingService.replaceUrl(API?.getAllGiftCardForSellscreen, { storeId })
    return HttpRoutingService.getMethod<getAllGiftCardForSellscreenResponse>(url)
})
export const postCheckoutSummaryApi = createAsyncThunk("sellScreen/postCheckoutSummaryApi", ({ storeId, payload }: { storeId: number, payload: checkoutPayload }) => {
    let url = HttpRoutingService.replaceUrl(API?.checkout, { storeId })
    return HttpRoutingService?.postMethod<checkoutSummaryResponse>(url, payload)
})

//Sellscreen payment
export const placeOrder = createAsyncThunk("sellscreen/placeOrder", ({ payload, storeId }: { payload: placeOrderPayload, storeId: number }) => {
    let url = HttpRoutingService.replaceUrl(API?.placeOrders, { storeId })
    return HttpRoutingService?.postMethod<placeOrderResponse>(url, payload, null, "v2/")
})

export const getOnePurchasedGiftCardDetails = createAsyncThunk("sellScreen/getOnePurchasedGiftCardDetails", ({ storeId, coupon }: { storeId: number, coupon: string }) => {
    let url = HttpRoutingService.replaceUrl(API?.getOnePurchasedGiftCardForPayment, { storeId, coupon })
    return HttpRoutingService.getMethod<getOneGiftCardResponse>(url)
})

export const discountValue = ({ discountAmount, originalPrice, quantity }: { discountAmount: number, originalPrice: number, quantity: number }) => {
    return ((discountAmount / (originalPrice * quantity)) * 100).toFixed(2)
}
export const calculateDiscount = (originalPrice: number, editedPrice: number) => {
    return Number((((originalPrice - editedPrice) / originalPrice) * 100).toFixed(2))
}
export const calculateDiscountAmount = (originalPrice: number, discountValue: number) => {
    return (originalPrice - (originalPrice * discountValue)).toFixed(2)
}

export const restrictionCheck = ({
    minValue,
    restrictionType,
    totalAmount,
    totalQuantity,
    value
}: {
    value: string,
    totalAmount: number,
    totalQuantity: number,
    restrictionType: NonNullable<checkoutDiscountsType["couponDiscount"]>["restrictionType"],
    minValue: number
}) => {
    if (restrictionType == "MINIMUM_PURCHASE_AMOUNT") {
        if (totalAmount < minValue) {
            return ""
        } else {
            return value
        }
    }
    if (restrictionType == "MINIMUM_QUANTITY_OF_ITEMS") {
        if (totalQuantity < minValue) {
            return ""
        } else {
            return value
        }
    } else {
        return value
    }
}

export const validateCoupon = ({
    couponDiscountValues,
    totalAmount,
    checkRestriction,
    ...props
}: validationCouponType) => {
    let result = { ...couponDiscountValues }
    if (totalAmount) {
        if (couponDiscountValues?.type == "Fixed") {
            let fixedValue = couponDiscountValues?.discount!!
            if (checkRestriction) {
                let couponTypeResult = result as NonNullable<checkoutDiscountsType["couponDiscount"]>
                fixedValue = restrictionCheck({
                    minValue: couponTypeResult?.minValue!!,
                    restrictionType: couponTypeResult?.restrictionType,
                    totalAmount,
                    totalQuantity: (props as { totalQuantity: number }).totalQuantity,
                    value: fixedValue
                })
            }
            if (totalAmount >= Number(fixedValue)) {
                result.value = fixedValue
            }
            else {
                result.value = ""
            }
        }
        else {
            let percentageValue = (totalAmount * (Number(couponDiscountValues?.discount!!) / 100)).toString()
            if (checkRestriction) {
                let couponTypeResult = result as NonNullable<checkoutDiscountsType["couponDiscount"]>
                result.value = restrictionCheck({
                    minValue: couponTypeResult?.minValue!!,
                    restrictionType: couponTypeResult?.restrictionType,
                    totalAmount,
                    totalQuantity: (props as { totalQuantity: number }).totalQuantity,
                    value: percentageValue
                })
            } else {
                result.value = percentageValue
            }
        }
    } else {
        result.value = ""
    }
    return result
}

const resetCart = (state: InitialState) => {
    state.checkoutProducts = []
    state.checkoutDiscounts = {}
    state.checkoutNotes = customerNotesInitialValue
    state.checkoutSummary = checkoutSummaryInitialValues
    state.checkoutGrandTotal = checkoutGrandTotalInitialValue
}
export const calculateTip = ({ subTotal, tipPercent, type, value }: { type: NonNullable<checkoutDiscountsType["couponDiscount"]>["type"], value: number, subTotal: number, tipPercent: number }) => {
    if (type == "Fixed") {
        return value
    } else {
        return subTotal * (tipPercent / 100)
    }
}

export const calculateGrandTotal = ({ additionalCharge, shipping, subTotal, tax, tip }: {
    subTotal: number,
    tax: number,
    shipping: number,
    additionalCharge: number,
    tip: number
}) => {
    let addedAmounts = subTotal + shipping + tax + additionalCharge + tip
    return addedAmounts
}
export const calculateDiscountPrice = ({ subTotal, additionalDiscount, couponDiscount, otherDiscount }:
    {
        subTotal: number,
        otherDiscount: number
        couponDiscount: number
        additionalDiscount: number
    }) => {
    const discountedPrice = subTotal - (otherDiscount + couponDiscount + additionalDiscount)
    return discountedPrice
}

const appendDiscountForEachProduct = ({ couponDiscount, additionalDiscount, checkoutProducts, subTotal }: {
    couponDiscount: checkoutDiscountsType["couponDiscount"]
    additionalDiscount: checkoutDiscountsType["additionalDiscount"]
    checkoutProducts: localCartProductType[]
    subTotal: number
}) => {
    let newCheckoutProducts: localCartProductType[] = [...checkoutProducts]
    let discountValue: number = 0
    let discountType: "Fixed" | "Percentage"
    if (couponDiscount?.code) {
        discountType = couponDiscount?.type
        discountValue = Number(couponDiscount?.value)
    }
    if (additionalDiscount?.value) {
        discountType = additionalDiscount?.type
        discountValue = Number(additionalDiscount?.value)
    }
    if (discountValue) {
        newCheckoutProducts = checkoutProducts?.map(((product) => {
            let productPrice = Number(product?.variant?.price) * Number(product?.quantity)
            let posPrice: number = 0
            let discount: number = 0
            if (discountType == "Percentage") {
                let discountPerc = productPrice * (discountValue / 100)
                posPrice = Number((productPrice - discountPerc).toFixed(2))
                discount = discountValue
            } else {
                let productShare = productPrice / subTotal
                discount = productShare * discountValue
                posPrice = Number(((productPrice - discount) / Number(product?.quantity)).toFixed(2))
            }
            return {
                ...product,
                posPrice,
                discount
            }
        }))
    }
    return newCheckoutProducts
}

const commonSetCheckoutProducts = (state: InitialState, action?: localCartProductType[]) => {
    let newCheckoutProducts = [...(action || state.checkoutProducts)]
    let { total_quantity, otherDiscount, product_count, subTotal, tax } = newCheckoutProducts.reduce((acc, value) => {
        if (!(value?.isProductNotAvailable || value?.isUnstock)) {
            let subTotal = (Number(value?.variant?.price) * Number(value?.quantity) || 0)
            return {
                subTotal: acc.subTotal + subTotal,
                tax: acc.tax + (value.taxAmount ?? 0),
                otherDiscount: acc.otherDiscount + value.discount,
                total_quantity: acc.total_quantity + (Number(value?.quantity) || 0),
                product_count: acc.product_count + 1
            }
        }
        else {
            return acc
        }
    }, { subTotal: 0, tax: 0, otherDiscount: 0, total_quantity: 0, product_count: 0 })
    let checkoutDiscountState = { ...state.checkoutDiscounts }
    let couponDiscount = validateCoupon({
        couponDiscountValues: checkoutDiscountState?.couponDiscount || couponInitialValue,
        totalAmount: subTotal,
        checkRestriction: true,
        totalQuantity: total_quantity
    }) as checkoutDiscountsType["couponDiscount"]

    let additionalDiscount = validateCoupon({
        couponDiscountValues: checkoutDiscountState?.additionalDiscount || discountsInitialValue,
        totalAmount: subTotal
    })

    newCheckoutProducts = appendDiscountForEachProduct({
        additionalDiscount,
        checkoutProducts: newCheckoutProducts,
        couponDiscount,
        subTotal
    })

    state.checkoutProducts = [...newCheckoutProducts]

    let additionalCharge: checkoutDiscountsType["additionalCharge"] = validateCoupon({
        couponDiscountValues: checkoutDiscountState?.additionalCharge || discountsInitialValue,
        totalAmount: subTotal
    })
    let tip: checkoutDiscountsType["tip"] = checkoutDiscountState?.tip ? {
        ...checkoutDiscountState?.tip,
        value: calculateTip({
            subTotal: subTotal,
            tipPercent: checkoutDiscountState.tip.tip,
            type: checkoutDiscountState.tip.type,
            value: checkoutDiscountState.tip.value
        })
    } : { type: "Fixed", value: 0, tip: 0 }

    state.checkoutDiscounts = {
        ...checkoutDiscountState,
        tip,
        couponDiscount,
        additionalDiscount,
        additionalCharge,
    }
    let discountedPrice = calculateDiscountPrice({
        subTotal,
        otherDiscount,
        couponDiscount: Number(couponDiscount?.value) || 0,
        additionalDiscount: Number(additionalDiscount?.value) || 0
    })
    state.checkoutSummary = [
        { name: "SubTotal", value: subTotal },
        { name: "Other Discount", value: otherDiscount },
        { name: "Coupon Discount", value: couponDiscount!! },
        { name: "Additional Discount", value: additionalDiscount },
        { name: "Discounted Price", value: discountedPrice },
        { name: "Tax", value: tax ?? 0 },
        { name: "Pickup Charge", value: 0 },
        { name: "Additional Charge", value: additionalCharge },
        { name: "Tip", ...tip }
    ]
    state.checkoutGrandTotal = {
        value: calculateGrandTotal({
            subTotal: discountedPrice,
            tax: tax ?? 0,
            additionalCharge: Number(additionalCharge?.value) || 0,
            tip: Number(tip?.value) || 0,
            shipping: 0
        }),
        productCount: product_count,
        quantity: total_quantity
    }
}
export const getCurrentDate = () => {
    const date = new Date();
    const datePart = date.toLocaleDateString('en-US', { month: "long", day: "2-digit", year: "numeric" });
    const timePart = date.toLocaleTimeString('en-US', { hour12: true });
    return datePart.replace(",", "") + ", " + timePart
}

const getOfferValue = ({ type, discountValue, checkoutProducts, currencySymbol }: { type: overAllDiscount["discountType"]["discountName"], discountValue: string, checkoutProducts: localCartProductType[], currencySymbol: string }) => {
    let { totalAmt } = checkoutProducts?.reduce((acc, value) => {
        return {
            totalAmt: acc.totalAmt + (Number(value.posPrice) * Number(value?.quantity) || 0),
        }
    }, { totalAmt: 0 })
    if (type == "Fixed") {
        return {
            offerValue: `${CommonService.currencyStandard(currencySymbol, String(discountValue))} OFF`,
            offerDescription: `Save ${CommonService.currencyStandard(currencySymbol, String(discountValue))} instantly! Use this coupon and pay only ${CommonService.currencyStandard(currencySymbol, String(totalAmt - Number(discountValue)))} at checkout`
        }
    } else {
        return {
            offerValue: `${discountValue}% OFF`,
            offerDescription: `Flat ${discountValue}% OFF with this coupon! Pay just ${CommonService.currencyStandard(currencySymbol, String(calculateDiscountAmount(totalAmt, (Number(discountValue) / 100))))} after discount`
        }
    }
}

export const sellScreenSlice = createSlice({
    name: "sellScreen",
    initialState,
    reducers: {
        setSellscreenLoader(state, action: PayloadAction<boolean>) {
            state.sellscreenLoader = action.payload
        },
        setSplitPaymentPaidData(state, action: PayloadAction<splitPaymentDataType[]>) {
            state.splitPaymentPaidData = action.payload
        },
        setIsGiftcardList(state, action: PayloadAction<boolean>) {
            state.isGiftCardList = action?.payload
        },
        setResetCart(state) {
            state.checkoutDiscounts = {}
            state.checkoutSummary = checkoutSummaryInitialValues
            state.checkoutGrandTotal = checkoutGrandTotalInitialValue
        },
        selectCustomer(state, action: PayloadAction<{ id: number, name: string, email?: string, phone?: string } | null>) {
            state.selectedCustomer = action?.payload
            resetCart(state)
        },
        setParkSale(state, action: PayloadAction<retriveSaleType[]>) {
            state.selectedCustomer = null
            state.retrievingSales = action.payload
            state.checkoutProducts = []
            state.checkoutNotes = customerNotesInitialValue
            state.cartProductsForList = new Map([])
            state.cartProductsForDetails = new Map()
        },
        setCheckoutNotes(state, action: PayloadAction<{ customerNotes?: string, orderNotes?: string }>) {
            let { customerNotes, orderNotes } = action?.payload
            state.checkoutNotes = {
                ...state.checkoutNotes,
                ...orderNotes !== undefined && { orderNotes },
                ...customerNotes !== undefined && { customerNotes }
            }
        },
        setTempCheckoutProducts(state, action: PayloadAction<{ quantity?: number | string, product: localCartProductType, quantityError?: string, quantityEdit?: boolean, posPrice?: number | string }>) {
            let { product, posPrice, quantity, quantityEdit, quantityError } = action?.payload
            let data = state.checkoutProducts.map((item) => {
                if (item?.productId == product?.productId && item?.variantId == product?.variantId) {
                    let temp = {
                        ...item,
                        ...quantityEdit && { quantityEdit: quantityEdit },
                        ...quantity !== undefined && { quantity: quantity },
                        ...quantityError !== undefined && { quantityError: quantityError },
                        ...posPrice !== undefined && { posPrice: posPrice }
                    }
                    return temp
                }
                return item
            })
            state.checkoutProducts = [...data]
        },
        setCheckoutDiscounts(state, action: PayloadAction<checkoutDiscountsType & { isUpdateCheckout?: true }>) {
            state.checkoutDiscounts = {
                couponDiscount: action?.payload?.couponDiscount,
                additionalDiscount: action?.payload?.additionalDiscount,
                additionalCharge: action?.payload?.additionalCharge,
                tip: action?.payload?.tip,
            }
            if (!action?.payload?.isUpdateCheckout) {
                let discountedPrice = calculateDiscountPrice({
                    subTotal: state.checkoutSummary[0].value,
                    otherDiscount: state.checkoutSummary[1].value,
                    couponDiscount: Number(action?.payload?.couponDiscount?.value) || 0,
                    additionalDiscount: Number(action?.payload?.additionalDiscount?.value) || 0
                })
                state.checkoutSummary = [
                    { name: "SubTotal", value: state.checkoutSummary[0].value },
                    { name: "Other Discount", value: state.checkoutSummary[1].value },
                    { name: "Coupon Discount", value: action?.payload?.couponDiscount || couponInitialValue },
                    { name: "Additional Discount", value: action?.payload?.additionalDiscount || discountsInitialValue },
                    { name: "Discounted Price", value: discountedPrice },
                    { name: "Tax", value: state.checkoutSummary[5].value ?? 0 },
                    { name: "Pickup Charge", value: 0 },
                    { name: "Additional Charge", value: action?.payload?.additionalCharge || discountsInitialValue },
                    { name: "Tip", value: action?.payload?.tip?.value || 0, type: action?.payload?.tip?.type || "Fixed", tip: action?.payload?.tip?.tip || 0 }
                ]
                state.checkoutGrandTotal = {
                    ...state.checkoutGrandTotal,
                    value: calculateGrandTotal({
                        subTotal: state.checkoutSummary[4].value,
                        tax: state.checkoutSummary[5].value ?? 0,
                        additionalCharge: Number(action?.payload?.additionalCharge?.value) || 0,
                        tip: Number(action?.payload?.tip?.value) || 0,
                        shipping: 0
                    })
                }
            }
            else {
                let couponDiscount = action?.payload?.couponDiscount
                let additionalDiscount = action?.payload?.additionalDiscount
                if (!couponDiscount?.code && !additionalDiscount?.value) {
                    let newCheckoutProducts = state.checkoutProducts?.map(((product) => {
                        return {
                            ...product,
                            posPrice: Number(product?.variant?.price),
                            discount: 0
                        }
                    }))
                    commonSetCheckoutProducts(state, newCheckoutProducts)
                } else
                    commonSetCheckoutProducts(state)
            }
        },
        setCheckoutGiftCart(state, action: PayloadAction<CheckoutGiftCart | null>) {
            state.checkoutGiftCart = action?.payload
        },
        setCheckoutGiftCartValue(state, action: PayloadAction<CheckoutGiftCart["giftCardValue"]>) {
            state.checkoutGiftCart = { ...state.checkoutGiftCart!!, giftCardValue: action.payload }
        }
    },
    extraReducers: (builder) => {
        builder
            //sellscreen category API
            .addCase(getAllCategoriesForSellscreen?.pending, (state) => {
                state.sellScreenCategories.loading = true
            })
            .addCase(getAllCategoriesForSellscreen?.fulfilled, (state, { payload }) => {
                let data = payload.category
                let allProduct = [
                    // { "id": -2, "categoryName": "Gift cards", "categoryImageUrl": null, "sortOrder": 0, "parentCategoryId": -2, "subCategory": [] },
                    { "id": -1, "categoryName": "All products", "categoryImageUrl": null, "sortOrder": 0, "parentCategoryId": -1, "subCategory": [] }]
                if (data?.length) {
                    data?.unshift(...allProduct)
                }
                else {
                    data.push(...allProduct)
                }
                state.sellScreenCategories.value = data
                state.sellScreenCategories.loading = false
            })
            .addCase(getAllCategoriesForSellscreen?.rejected, (state, payload) => {
                state.sellScreenCategories.loading = false
                state.sellScreenCategories.error = payload.error.message as string
            })
            //sellscreen product API
            .addCase(getCategoryProductsForSellScreen?.pending, (state) => {
                state.sellScreenProducts.loading = true
                // state.sellScreenProducts.endReached = false
            })
            .addCase(getCategoryProductsForSellScreen?.fulfilled, (state, payload) => {
                let { offset } = payload?.meta?.arg?.payload
                let products: productList[] = []
                if (offset > 0) {
                    products = [...state.sellScreenProducts?.value, ...payload.payload.products]
                } else {
                    products = payload.payload.products || []
                }
                if (payload.payload?.products?.length) {
                    state.sellScreenProducts.endReached = false
                }
                else {
                    state.sellScreenProducts.endReached = true
                }
                state.sellScreenProducts.value = products
                state.sellScreenProducts.loading = false
                if (state?.selectedCustomer == null) {
                    state.sellscreenLoader = false
                }
            })
            .addCase(getCategoryProductsForSellScreen?.rejected, (state, payload) => {
                state.sellScreenProducts.loading = false
                state.sellScreenProducts.error = payload.error.message as string
                if (state?.selectedCustomer == null) {
                    state.sellscreenLoader = false
                }
            })

            //------SellScreen checkout------

            //create anonymous customer api
            .addCase(createAnonymousCustomerApi?.pending, (state) => {
                state.createAnonymousCustomer.loading = true
            })
            .addCase(createAnonymousCustomerApi?.fulfilled, (state, payload) => {
                state.createAnonymousCustomer.loading = false
                if (payload?.payload?.customerDetails?.id) {
                    let { customerDetails: { first_name, last_name, id } } = payload?.payload
                    state.selectedCustomer = { id, name: first_name + " " + last_name }
                }
            })
            .addCase(createAnonymousCustomerApi?.rejected, (state, payload) => {
                state.createAnonymousCustomer.loading = false
                state.createAnonymousCustomer.error = payload.error.message as string
            })

            //Get All POSCustomer API
            .addCase(getAllPOSCustomerApi?.pending, (state) => {
                state.getAllPOSCustomer.loading = true
            })
            .addCase(getAllPOSCustomerApi?.fulfilled, (state, payload) => {
                state.getAllPOSCustomer.loading = false
                state.getAllPOSCustomer.value = payload?.payload?.customers
            })
            .addCase(getAllPOSCustomerApi?.rejected, (state, payload) => {
                state.getAllPOSCustomer.loading = false
                state.getAllPOSCustomer.error = payload.error.message as string
            })
            .addCase(getCartProducts.fulfilled, (state, payload) => {
                let cartItems = payload.payload?.cartProducts?.cartProducts || []
                if (cartItems?.length == 0) {
                    state.checkoutProducts = []
                    state.cartProductsForList = new Map([])
                    state.cartProductsForDetails = new Map()
                    state.sellscreenLoader = false
                } else {
                    let checkoutProductsResult: localCartProductType[] = []
                    let cartProductsListResult: cartProductsMapType = new Map([])
                    let cartProductsDetailsResult: cartProductsMapType = new Map([])
                    for (const item of cartItems) {
                        let posPrice = item?.posPrice == null ? Number(item?.variant?.price) : Number(item?.posPrice)
                        const discountValue = Number(item?.posPrice) ? Number(item?.quantity) * (item?.variant?.price - Number(item?.posPrice)) : 0
                        checkoutProductsResult.push({
                            ...item,
                            discount: discountValue,
                            posPrice,
                            posProductName: item?.posProductName || (item?.isVariants ? (item?.product?.name + " - " + item?.variant?.variantName) : item?.product?.name),
                            quantityEdit: false
                        })
                        let details = {
                            quantity: Number(item?.quantity),
                            cartProductId: item?.id,
                            varientId: item?.variantId,
                            productNotes: item?.instruction || ""
                        }
                        cartProductsListResult.set(item.productId, details)
                        cartProductsDetailsResult.set(item.variantId, details)
                    }
                    commonSetCheckoutProducts(state, checkoutProductsResult)
                    state.cartProductsForList = cartProductsListResult
                    state.cartProductsForDetails = cartProductsDetailsResult
                    state.sellscreenLoader = false
                }
            })
            .addCase(getCartProducts.rejected, (state) => {
                ZenToast({
                    type: "error",
                    message: "Failed to get the cart products"
                })
                state.sellscreenLoader = false
            })
            .addCase(deleteCartProduct.fulfilled, () => {
                ZenToast({
                    type: "success",
                    message: "Product removed from the cart successfully"
                })
            })
            .addCase(deleteCartProduct.rejected, (state) => {
                ZenToast({
                    type: "error",
                    message: "Failed to remove the product from the cart"
                })
                state.sellscreenLoader = false
            })
            .addCase(updateCartProducts.fulfilled, () => {
                ZenToast({
                    type: "success",
                    message: "Product updated to the cart succesfully"
                })
            })
            .addCase(updateCartProducts.rejected, (state) => {
                state.sellscreenLoader = false
                ZenToast({
                    type: "error",
                    message: "Failed to update the Product to the cart"
                })
            })
            .addCase(deleteCart.fulfilled, (state, payload) => {
                const { isDeleteCustomer } = payload?.meta?.arg
                if (isDeleteCustomer) {
                    state.selectedCustomer = null
                    ZenToast({
                        type: "success",
                        message: "Customer deleted successfully"
                    })
                } else {
                    ZenToast({
                        type: "success",
                        message: "Cart deleted successfully"
                    })
                }
            })
            .addCase(deleteCart.rejected, (state) => {
                ZenToast({
                    type: "error",
                    message: "Failed to delete the cart"
                })
                state.sellscreenLoader = false
            })
            .addCase(getAllEligibleDiscount.fulfilled, (state, action) => {
                state.getAllEligibleDiscount = action?.payload?.discounts?.overAllDiscounts?.map((item) => {
                    let { offerDescription, offerValue } = getOfferValue({ discountValue: item?.discountValue, type: item?.discountType?.discountName, checkoutProducts: state?.checkoutProducts, currencySymbol: action?.payload?.currencySymbol })
                    return {
                        ...item,
                        offerValue,
                        offerDescription
                    }
                })
            })
            .addCase(getAllEligibleDiscount?.rejected, () => {
                ZenToast({ type: "error", message: "Failed to get a eligible discounts" })
            })
            .addCase(addCartProducts.fulfilled, () => {
                ZenToast({
                    type: "success",
                    message: "Product added to the cart succesfully"
                })
            })
            .addCase(addCartProducts.rejected, (state) => {
                state.sellscreenLoader = false
                ZenToast({
                    type: "error",
                    message: "Failed to add the Product to the cart"
                })
            })
            .addCase(getAllGiftCardsForSellScreen.fulfilled, (state, action) => {
                state.sellscreenGiftCardList = action?.payload?.giftCard
            })
            .addCase(getAllGiftCardsForSellScreen.rejected, () => {
                ZenToast({
                    type: "error",
                    message: "Failed to get the gift carts for sellscreen"
                })
            })
            .addCase(postCheckoutSummaryApi.fulfilled, (state, action) => {
                let data = { ...action?.payload?.checkoutData }

                const couponDiscount = state?.checkoutDiscounts?.couponDiscount
                const additionalDiscount = state?.checkoutDiscounts?.additionalDiscount
                let overAllQuantity = 0
                let otherDiscount = 0
                let checkoutProductsMap: Map<number, { discount: number, posPrice: number }> = new Map([])

                let discountId: null | number = null
                let appliedDiscountValue = 0
                if (couponDiscount?.code) {
                    discountId = couponDiscount?.discountId
                    appliedDiscountValue = Number(couponDiscount?.value)
                }
                if (additionalDiscount?.value) {
                    appliedDiscountValue = Number(additionalDiscount?.value)
                }
                if (appliedDiscountValue) {
                    for (let { discount, variantId, posPrice } of state?.checkoutProducts) {
                        checkoutProductsMap.set(variantId, { discount: Number(discount) || 0, posPrice: Number(posPrice) || 0 })
                    }
                }
                data.cartData = {
                    ...data?.cartData,
                    cartProducts: data?.cartData?.cartProducts?.map((product) => {
                        overAllQuantity += Number(product?.quantity)
                        let productDiscountAmount = 0
                        let productPosPrice = product.productPrice
                        if (appliedDiscountValue) {
                            let { discount, posPrice } = checkoutProductsMap?.get(product?.variantId)!!
                            productPosPrice = posPrice
                            productDiscountAmount = discount
                        } else if (product?.posPrice) {
                            productPosPrice = Number(product?.posPrice)
                            productDiscountAmount = Number(product?.quantity) * (product?.variant?.price - Number(product?.posPrice))
                            otherDiscount += productDiscountAmount
                        }
                        return {
                            ...product,
                            ...appliedDiscountValue &&
                            {
                                discountId,
                                appliedDiscountValue
                            },
                            productPrice: productPosPrice,
                            discountAmount: productDiscountAmount
                        }
                    })
                }
                const { subTotal, taxAmount, shipping, tipAmount, additionalCharge } = data.overAllSummary
                data.overAllSummary = {
                    ...data.overAllSummary,
                    additionalDiscount: additionalDiscount?.value ? appliedDiscountValue : 0,
                    couponDiscount: couponDiscount?.code ? appliedDiscountValue : 0,
                    otherDiscount,
                    get discountedPrice() {
                        return calculateDiscountPrice({
                            subTotal: subTotal + this.otherDiscount,
                            additionalDiscount: this.additionalDiscount,
                            couponDiscount: this.couponDiscount,
                            otherDiscount: this.otherDiscount
                        })
                    },
                    get totalAmount() {
                        return calculateGrandTotal({
                            subTotal: this.discountedPrice,
                            tax: taxAmount,
                            shipping,
                            tip: tipAmount,
                            additionalCharge
                        })
                    },
                    overAllQuantity
                }
                state.checkoutSummaryResponse = { ...data }
            })
            .addCase(postCheckoutSummaryApi.rejected, (state) => {
                state.checkoutSummaryResponse = null
            })
    }
})
export const {
    selectCustomer,
    setParkSale,
    setCheckoutDiscounts,
    setSellscreenLoader,
    setResetCart,
    setTempCheckoutProducts,
    setCheckoutNotes,
    setIsGiftcardList,
    setCheckoutGiftCart,
    setCheckoutGiftCartValue,
    setSplitPaymentPaidData
} = sellScreenSlice?.actions
export default sellScreenSlice?.reducer